import { useState, useEffect, useRef, useCallback } from 'react';
import { LeftPanel } from './LeftPanel';
import { SchemaViewer } from './SchemaViewer';
import { SchemaEditor } from './SchemaEditor';

export const Layout = () => {
  const [topPanelHeight, setTopPanelHeight] = useState(window.innerHeight * 0.65);
  const isDragging = useRef(false);

  const handleMouseDown = (e: React.MouseEvent) => {
    isDragging.current = true;
    e.preventDefault();
  };

  const handleMouseUp = useCallback(() => {
    isDragging.current = false;
  }, []);

  const handleMouseMove = useCallback((e: MouseEvent) => {
    if (!isDragging.current) return;
    setTopPanelHeight(e.clientY);
  }, []);

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);
  
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <LeftPanel />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <div style={{ height: `${topPanelHeight}px`, overflowY: 'auto', flexShrink: 0 }} data-testid="schema-viewer">
          <SchemaViewer />
        </div>
        <div 
          onMouseDown={handleMouseDown}
          style={{ 
            height: '10px', 
            backgroundColor: '#ddd', 
            cursor: 'row-resize',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <svg width="25" height="4" viewBox="0 0 25 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="0" width="25" height="1" fill="#888"/>
            <rect x="0" y="3" width="25" height="1" fill="#888"/>
          </svg>
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }} data-testid="schema-editor">
          <SchemaEditor />
        </div>
      </div>
    </div>
  );
};